import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const CashTransactionDepositIcon: FC<SvgProps> = (props) => (
    <Svg height={16} viewBox="0 0 16 16" width={16} {...props}>
        <Path
            d="M8 12.7664C7.7888 12.7664 7.60267 12.6859 7.4416 12.5248C7.28053 12.3637 7.2 12.1776 7.2 11.9664V8.8H4.0336C3.8224 8.8 3.63627 8.71947 3.4752 8.5584C3.31413 8.39733 3.2336 8.2112 3.2336 8C3.2336 7.7888 3.31413 7.60267 3.4752 7.4416C3.63627 7.28053 3.8224 7.2 4.0336 7.2H7.2V4.0336C7.2 3.8224 7.28053 3.63627 7.4416 3.4752C7.60267 3.31413 7.7888 3.2336 8 3.2336C8.2112 3.2336 8.39733 3.31413 8.5584 3.4752C8.71947 3.63627 8.8 3.8224 8.8 4.0336V7.2H11.9664C12.1776 7.2 12.3637 7.28053 12.5248 7.4416C12.6859 7.60267 12.7664 7.7888 12.7664 8C12.7664 8.2112 12.6859 8.39733 12.5248 8.5584C12.3637 8.71947 12.1776 8.8 11.9664 8.8H8.8V11.9664C8.8 12.1776 8.71947 12.3637 8.5584 12.5248C8.39733 12.6859 8.2112 12.7664 8 12.7664Z"
            fill="#26925C"
        />
    </Svg>
)

export default CashTransactionDepositIcon
